import React from 'react';

import { makeStyles, Theme } from '@material-ui/core';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';

import { Typography } from '../Typography';

export interface TippingProps {
  tippingOptions: string[];
}

const useStyles = makeStyles((theme: Theme) => ({
  tippingButtonGroup: {
    alignItems: 'center',
  },
  tippingButton: {
    borderColor: theme.palette.common.black,
    color: theme.palette.common.black,
    fontWeight: theme.typography.fontWeightRegular,
    minWidth: theme.spacing(6.75),
    padding: theme.spacing(1, 1.2),
    '&.Mui-selected': {
      backgroundColor: theme.palette.common.white,
      border: `2px solid ${theme.palette.primary.main}`,
      color: theme.palette.common.black,
      padding: theme.spacing(1.4),
    },
  },
}));

export const Tipping = (props: TippingProps) => {
  const { tippingOptions } = props;
  const classes = useStyles();

  return (
    <ToggleButtonGroup className={classes.tippingButtonGroup}>
      {tippingOptions.map((option, index) => (
        <ToggleButton
          key={index}
          className={classes.tippingButton}
          selected={false}
        >
          <Typography>{option}</Typography>
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};
